module.exports = __webpack_public_path__ + "labioplastika_11_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_11_after.jpg
// module id = 1065
// module chunks = 0